import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'

export default {
    get() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask`, AUTH_HEADERS())
    },
    getMapTaskLocations(startDate, endDate) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/mapLocations?startDate=${startDate}&endDate=${endDate}`, AUTH_HEADERS())
    },
    getWorkerMapTaskLocations() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/workerMapLocations`, AUTH_HEADERS())
    },
    getActiveRange(keywords, limit, offset, startDate, endDate) {
        return axios.get(
            `${process.env.VUE_APP_BASE_URL}JobTask/activeRange?keywords=${keywords}&limit=${limit}&offset=${offset}&startDate=${startDate}&endDate=${endDate}`,
            AUTH_HEADERS())
    },
    getArchivedRange(keywords, limit, offset) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/archivedRange?keywords=${keywords}&limit=${limit}&offset=${offset}`, AUTH_HEADERS())
    },
    getDelayedRange(keywords, limit, offset) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/delayedRange?keywords=${keywords}&limit=${limit}&offset=${offset}`, AUTH_HEADERS())
    },
    getInProgressRange(keywords, limit, offset) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/inProgressRange?keywords=${keywords}&limit=${limit}&offset=${offset}`, AUTH_HEADERS())
    },
    assignTask(taskId, routeId) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/assignTask?taskId=${taskId}&routeId=${routeId}`, AUTH_HEADERS())
    },
    getArchived() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/archived`, AUTH_HEADERS())
    },
    getDelayed() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/delayed`, AUTH_HEADERS())
    },
    getInProgress() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/inProgress`, AUTH_HEADERS())
    },
    getCompleted() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/completed`, AUTH_HEADERS())
    },
    getById(id) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/${id}`, AUTH_HEADERS())
    },
    getTaskNumbers() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/taskNumbers`, AUTH_HEADERS())
    },
    getActiveCount() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/activeCount`, AUTH_HEADERS())
    },
    getArchivedCount() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/archivedCount`, AUTH_HEADERS())
    },
    getDelayedCount() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/delayedCount`, AUTH_HEADERS())
    },
    getInProgressCount() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/inProgressCount`, AUTH_HEADERS())
    },
    create(jobTask) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}JobTask/create`, jobTask, AUTH_HEADERS())
    },
    update(jobTask) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}JobTask/update`, jobTask, AUTH_HEADERS())
    },
    complete(id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}JobTask/complete/${id}`, id, AUTH_HEADERS())
    },
    delete(id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}JobTask/delete/${id}`, id, AUTH_HEADERS())
    },
    archive(id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}JobTask/archive/${id}`, id, AUTH_HEADERS())
    },
    restore(id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}JobTask/restore/${id}`, id, AUTH_HEADERS())
    },
    archiveGroup(idList) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}JobTask/archiveGroup`, idList, AUTH_HEADERS())
    },
    getTaskNumberAndAddress() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}JobTask/taskNumberAndAddress`, AUTH_HEADERS())
    }
}
